import { render, staticRenderFns } from "./HtmlComponent.vue?vue&type=template&id=2f196306&scoped=true"
import script from "./HtmlComponent.vue?vue&type=script&lang=js"
export * from "./HtmlComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f196306",
  null
  
)

export default component.exports